import type { VerbTypes } from 'modules/core/lib/verbTypes'
import Policy from 'modules/core/store/models/policies/Policy'

class CustomResourcesResourcePolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'changeCustomResource':
        return this.permissions.change

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default CustomResourcesResourcePolicy
